"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Check_1 = require("./../Check");
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode(props) {
        var _this = _super.call(this, props) || this;
        _this.treeNodeRef = react_1.default.createRef();
        _this.treeRootNodeRef = react_1.default.createRef();
        _this.treeChildrenNodeRef = react_1.default.createRef();
        _this.state = {
            foldStatus: false,
            visible: true,
        };
        return _this;
    }
    TreeNode.prototype.componentDidMount = function () {
        if (this.treeRootNodeRef.current && this.treeChildrenNodeRef.current) {
            var rWidth = this.treeRootNodeRef.current;
            var cWidth = this.treeChildrenNodeRef.current;
            var cValue = cWidth.clientWidth;
            var rValue = rWidth.clientWidth;
            if (cValue >= rValue - 89) {
                this.setState({
                    visible: false,
                });
            }
        }
    };
    TreeNode.prototype.render = function () {
        var _this = this;
        var _a = this.state, foldStatus = _a.foldStatus, visible = _a.visible;
        var _b = this.props, root = _b.root, showText = _b.showText, showLessText = _b.showLessText, data = _b.data, showListStatus = _b.showListStatus, _c = _b.currentIndex, currentIndex = _c === void 0 ? 0 : _c;
        var _d = data || {}, _e = _d.childRoot, childRoot = _e === void 0 ? false : _e, name = _d.name, aliasName = _d.aliasName, indeterminate = _d.indeterminate, disabled = _d.disabled, children = _d.children, _f = _d.collapsed, collapsed = _f === void 0 ? false : _f, _g = _d.checked, checked = _g === void 0 ? false : _g, key = _d.key;
        var caret;
        if (children) {
            if (children.length > 0) {
                caret = react_1.default.createElement("span", { className: "collapse ".concat(collapsed ? 'caret-right' : 'caret-down') });
            }
        }
        var variable = root || childRoot;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("tree-node tree-d-flex ".concat(!variable ? 'tree-node-m-top' : 'tree-node-m-width'), {
                'tree--hidden': childRoot && currentIndex > 4 && !showListStatus,
            }), draggable: true, ref: this.treeNodeRef },
            !root ? (react_1.default.createElement("div", { className: "inner tree-d-flex" },
                aliasName ? (react_1.default.createElement("span", { className: "content" },
                    react_1.default.createElement("span", { className: "alias-name ".concat(variable ? 'txt' : 'txt-child') },
                        aliasName,
                        " \uFF1A"))) : null,
                react_1.default.createElement("span", { className: "content" },
                    react_1.default.createElement(Check_1.CheckComponent, { checked: checked, name: name, indeterminate: indeterminate, disabled: disabled, onCheck: function () { var _a, _b; return (_b = (_a = _this.props).onCheck) === null || _b === void 0 ? void 0 : _b.call(_a, key); } }),
                    caret,
                    react_1.default.createElement("span", { className: (0, classnames_1.default)("".concat(variable ? 'txt' : 'txt-child'), {
                            disabled: disabled,
                        }) }, name)))) : null,
            children && children.length > 0 && (react_1.default.createElement("div", { ref: this.treeRootNodeRef, className: (0, classnames_1.default)("tree-wide--width ".concat(!root ? 'children-node tree-d-flex-wrap' : ''), {
                    'children-node--group': !root && foldStatus,
                }) },
                react_1.default.createElement("div", { className: (0, classnames_1.default)({
                        'tree-items': childRoot,
                        'tree-d-flex-wrap': variable,
                    }), ref: this.treeChildrenNodeRef }, children.map(function (item, index) { return (react_1.default.createElement(TreeNode, { currentIndex: index || 0, onCheck: _this.props.onCheck, key: item.key + String(index), data: item, showText: showText, showLessText: showLessText, showListStatus: showListStatus })); })),
                !root ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('switch switch--horizontal', {
                        'tree--hidden': visible,
                    }), onClick: function () {
                        _this.setState({
                            foldStatus: !foldStatus,
                        });
                    } }, !foldStatus ? showText : showLessText)) : null))));
    };
    return TreeNode;
}(react_1.default.Component));
exports.default = TreeNode;
//# sourceMappingURL=TreeNode.js.map